<a class="languageSelect" target="_blank" 
	href="../../pages/cs/sys/portal/documentation/documentation.faces?navigationPosition=documentation&site=Publikationen-psv-HISinOne.xhtml"
	title="{{'fs.res.publication.documentation' | hisUi}}">{{'de.his.portal.doku' | hisUi}}</a>
<div>
	<his-search-form configFile="{{SEARCH_CONFIG_UNITS_BY_PERSON}}"></his-search-form>
</div>
